export default {
    setUsers(state, {users})
    {
        state.users = users;
    },
}
